import { createAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';

export interface DeleteItem {
    msftTaskId: string;
}

export const deleteItem = createAction<ActionType, DeleteItem>(
    ActionType.TC__TL__DELETE_ITEM,
);
